const PEM_BLOCK_PATTERN = /-----BEGIN [^-]+-----|-----END [^-]+-----/g;
const PEM_BODY_PREVIEW_EDGE_CHAR_COUNT = 8;
export const PEM_BODY_MASK_SEPARATOR = "••••••••••••••••";
export const STORED_SECRET_MASK = `${"•".repeat(PEM_BODY_PREVIEW_EDGE_CHAR_COUNT)}${PEM_BODY_MASK_SEPARATOR}${"•".repeat(PEM_BODY_PREVIEW_EDGE_CHAR_COUNT)}`;

export function pemBodyWithoutHeaders(pem: string): string {
  return pem.replace(PEM_BLOCK_PATTERN, "").replace(/\s/g, "");
}

export function isObfuscatedStoredSecret(value: string): boolean {
  const trimmed = value.trim();
  if (!trimmed) {
    return false;
  }
  if (trimmed.includes("BEGIN")) {
    const body = pemBodyWithoutHeaders(trimmed);
    return body === "REDACTED";
  }
  return trimmed.includes("*");
}

export function maskedPemBodyPreview(body: string): string {
  const trimmed = body.trim();
  if (!trimmed) {
    return "";
  }
  if (trimmed.length <= 8) {
    return trimmed;
  }
  if (trimmed.length <= 16) {
    const head = Math.ceil(trimmed.length / 2);
    return `${trimmed.slice(0, head)}${PEM_BODY_MASK_SEPARATOR}${trimmed.slice(-head)}`;
  }
  return `${trimmed.slice(0, PEM_BODY_PREVIEW_EDGE_CHAR_COUNT)}${PEM_BODY_MASK_SEPARATOR}${trimmed.slice(-PEM_BODY_PREVIEW_EDGE_CHAR_COUNT)}`;
}

export function maskedPemPreview(pem: string): string {
  const trimmed = pem.trim();
  if (!trimmed) {
    return "";
  }
  if (isObfuscatedStoredSecret(trimmed)) {
    return STORED_SECRET_MASK;
  }
  const body = pemBodyWithoutHeaders(trimmed);
  if (body.length < 4) {
    return STORED_SECRET_MASK;
  }
  return maskedPemBodyPreview(body);
}

export function maskedPrivateKeyPreview(
  privateKeyPem: string,
  hasStoredPrivateKey: boolean
): string {
  if (privateKeyPem.trim()) {
    return maskedPemPreview(privateKeyPem);
  }
  if (hasStoredPrivateKey) {
    return STORED_SECRET_MASK;
  }
  return "";
}
